import Vue from 'vue'
import Router from 'vue-router'
import MainMenu from '@/components/MainMenu'
import ProductionItemInfo from '@/components/ProductionItemInfo'
import ScanPacking from '@/components/ScanPacking'
import ScanProduced from '@/components/ScanProduced'
import PackingSlipInfo from '@/components/PackingSlipInfo'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.FRONTEND_BASE,
  routes: [
    {
      path: '/',
      name: 'main-menu',
      component: MainMenu
    },
    {
      path: '/production-item-info',
      name: 'production-item-info',
      component: ProductionItemInfo
    },
    {
      path: '/packing-slip-info',
      name: 'packing-slip-info',
      component: PackingSlipInfo
    },
    {
      path: '/scan-packing',
      name: 'scan-packing',
      component: ScanPacking
    },
    {
      path: '/scan-produced',
      name: 'scan-produced',
      component: ScanProduced
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js